import type { PlatformPolicyConfig } from '../../lib/types';
import { computeAdhikara, type SubScores } from './compute';
import { type ArchetypeKey } from './weights';

export interface SwabhavaJaMismatchResult {
  signal: 'ALIGNED' | 'ARCHETYPE_MISMATCH';
  action: 'NONE' | 'ROUTE_TO_REASSESSMENT';
  registeredArchetype: ArchetypeKey;
  functionalArchetype: ArchetypeKey;
  reassessmentPath: string;
  scores: Record<ArchetypeKey, number>;
}

export function inferFunctionalArchetype(
  scores: SubScores,
  policy?: PlatformPolicyConfig | null,
): { archetype: ArchetypeKey; scores: Record<ArchetypeKey, number> } {
  const totals = {
    BRAHMIN: computeAdhikara(scores, 'BRAHMIN', policy).score,
    KSHATRIYA: computeAdhikara(scores, 'KSHATRIYA', policy).score,
    VAISHYA: computeAdhikara(scores, 'VAISHYA', policy).score,
    SHUDRA: computeAdhikara(scores, 'SHUDRA', policy).score,
  };

  const ordered = Object.entries(totals).sort((a, b) => b[1] - a[1]);
  return {
    archetype: ordered[0][0] as ArchetypeKey,
    scores: totals,
  };
}

export function detectSwabhavaJaAnomaly(
  registeredArchetype: ArchetypeKey,
  scores: SubScores,
  policy?: PlatformPolicyConfig | null,
): SwabhavaJaMismatchResult {
  const inferred = inferFunctionalArchetype(scores, policy);
  const mismatch = inferred.archetype !== registeredArchetype;
  return {
    signal: mismatch ? 'ARCHETYPE_MISMATCH' : 'ALIGNED',
    action: mismatch ? 'ROUTE_TO_REASSESSMENT' : 'NONE',
    registeredArchetype,
    functionalArchetype: inferred.archetype,
    reassessmentPath: mismatch ? '/profile?reassess=1' : '',
    scores: inferred.scores,
  };
}
